var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    fontSize: `${_vm.fontSize}px`,
    textAlign: _vm.textAlign,
    color: _vm.color,
    fontWeight: _vm.fontWeight
})},[_vm._v(_vm._s(_vm.showVal))])
}
var staticRenderFns = []

export { render, staticRenderFns }